// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 900;
  src: url('DMSans-Black.488392488fc1755c.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 800;
  src: url('DMSans-ExtraBold.a5b0ab310755ef77.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 700;
  src: url('DMSans-Bold.5d8f19212e66f41c.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 600;
  src: url('DMSans-SemiBold.ba81386aaa3f8bec.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 500;
  src: url('DMSans-Medium.6e411356edf4bc5d.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 400;
  src: url('DMSans-Regular.254fafcf32e78d93.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 300;
  src: url('DMSans-Light.195d851006084602.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 200;
  src: url('DMSans-ExtraLight.a1df2f9a2054461d.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 100;
  src: url('DMSans-Thin.a9d11007dfa31cfb.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 900;
  src: url('DMSans-BlackItalic.6085069ea3ad7499.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 800;
  src: url('DMSans-ExtraBoldItalic.43c17c588c612b92.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 700;
  src: url('DMSans-BoldItalic.05455c47a70f72be.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 600;
  src: url('DMSans-SemiBoldItalic.7afda8ff11873b51.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 500;
  src: url('DMSans-MediumItalic.2f9b70a7382ac1bd.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 400;
  src: url('DMSans-Italic.da827be69095140a.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 300;
  src: url('DMSans-LightItalic.9ac218ec8d449389.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 200;
  src: url('DMSans-ExtraLightItalic.201c8891fc6a2a4e.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 100;
  src: url('DMSans-ThinItalic.65c007651b2972db.ttf');
}
/* Old palette
\$accent-btn: #DD7EB0;
\$dark-text: #303f71;
\$light-text: #fff;
\$inactive-text: #A3AED0;
\$accent-blue: #84D9FD;*/
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 900;
  src: url('DMSans-Black.488392488fc1755c.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 800;
  src: url('DMSans-ExtraBold.a5b0ab310755ef77.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 700;
  src: url('DMSans-Bold.5d8f19212e66f41c.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 600;
  src: url('DMSans-SemiBold.ba81386aaa3f8bec.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 500;
  src: url('DMSans-Medium.6e411356edf4bc5d.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 400;
  src: url('DMSans-Regular.254fafcf32e78d93.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 300;
  src: url('DMSans-Light.195d851006084602.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 200;
  src: url('DMSans-ExtraLight.a1df2f9a2054461d.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 100;
  src: url('DMSans-Thin.a9d11007dfa31cfb.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 900;
  src: url('DMSans-BlackItalic.6085069ea3ad7499.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 800;
  src: url('DMSans-ExtraBoldItalic.43c17c588c612b92.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 700;
  src: url('DMSans-BoldItalic.05455c47a70f72be.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 600;
  src: url('DMSans-SemiBoldItalic.7afda8ff11873b51.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 500;
  src: url('DMSans-MediumItalic.2f9b70a7382ac1bd.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 400;
  src: url('DMSans-Italic.da827be69095140a.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 300;
  src: url('DMSans-LightItalic.9ac218ec8d449389.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 200;
  src: url('DMSans-ExtraLightItalic.201c8891fc6a2a4e.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 100;
  src: url('DMSans-ThinItalic.65c007651b2972db.ttf');
}
/* Old palette
\$accent-btn: #DD7EB0;
\$dark-text: #303f71;
\$light-text: #fff;
\$inactive-text: #A3AED0;
\$accent-blue: #84D9FD;*/
.rDNA-sidebar-container .rDNA-data-text p:first-child {
  font-family: "Dm Sans", sans-serif;
  font-size: 18px;
  font-weight: 700;
  font-style: normal;
}

.rDNA-sidebar-container .rDNA-data-button {
  font-family: "Dm Sans", sans-serif;
  font-size: 14px;
  font-weight: 700;
  font-style: normal;
}

.rDNA-sidebar-container .rDNA-linkTxt-active, .rDNA-sidebar-container .rDNA-linkTxt {
  font-family: "Dm Sans", sans-serif;
  font-size: 12px;
  font-weight: 700;
  font-style: normal;
}

.rDNA-sidebar-container .rDNA-linkContainer, .rDNA-sidebar-container .rDNA-listItem {
  display: flex;
  flex-direction: row;
}

/*
\$theme-darkGray: #7D7979;
\$theme-lightGray: #BDBDBD;
\$theme-peach: #FFF2E1;
\$theme-yellow: #FFBB64;
\$theme-orange: #FF9001;
\$theme-blue: #2A296F;
\$sub-header-theme: #95a5a6;*/
/** Colors variables */
.sb-default .sb-wrapper {
  --sb-color: #fff;
  --sb-background: var(--button-color);
  --sb-border-radius: 4px;
  --sb-overflow: hidden;
}
.sb-default .sb-wrapper.sb-show-icon.sb-show-text {
  --sb-text-padding: 0 1em 0 0;
}
.sb-default .sb-wrapper.sb-show-icon.sb-show-text .sb-text {
  filter: none;
}

/** Colors variables */
.sb-circles-dark .sb-wrapper, .sb-circles-light .sb-wrapper {
  --sb-color: #fff;
  --sb-background: transparent;
  --sb-min-width: fit-content;
  --sb-height: fit-content;
  --sb-icon-size: 1.4em;
}
.sb-circles-dark .sb-wrapper:active .sb-icon, .sb-circles-light .sb-wrapper:active .sb-icon {
  box-shadow: 0 7px 8px -4px rgba(0, 0, 0, 0.2), 0 12px 17px 2px rgba(0, 0, 0, 0.14), 0 5px 22px 4px rgba(0, 0, 0, 0.12);
}
.sb-circles-dark .sb-wrapper .sb-icon, .sb-circles-light .sb-wrapper .sb-icon {
  background-color: var(--button-color);
  box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.2), 0 6px 10px 0 rgba(0, 0, 0, 0.14), 0 1px 18px 0 rgba(0, 0, 0, 0.12);
  width: 2.5em;
  min-height: 2.5em;
  border-radius: 50%;
  transition: background 0.4s cubic-bezier(0.25, 0.8, 0.25, 1), box-shadow 280ms cubic-bezier(0.4, 0, 0.2, 1);
}
.sb-circles-dark .sb-wrapper .sb-text, .sb-circles-light .sb-wrapper .sb-text {
  color: var(--button-color);
  font-size: 0.8em;
  margin-top: 5px;
  border-radius: 1em;
  width: 100%;
  height: 1.8em;
  line-height: 1.8em;
  padding: 0;
  transition: background 0.4s cubic-bezier(0.25, 0.8, 0.25, 1), box-shadow 280ms cubic-bezier(0.4, 0, 0.2, 1);
}
.sb-circles-dark .sb-wrapper .sb-content, .sb-circles-light .sb-wrapper .sb-content {
  align-items: center;
  flex-direction: column;
}

.sb-circles-dark .sb-wrapper .sb-icon {
  background-color: var(--button-color);
}
.sb-circles-dark .sb-wrapper .sb-text {
  color: var(--button-color);
}

.sb-circles-light .sb-wrapper .sb-icon, .sb-circles-light .sb-wrapper .sb-text {
  color: var(--button-color);
}
.sb-circles-light .sb-wrapper .sb-icon {
  background: radial-gradient(ellipse farthest-corner at center, white 30%, #f2f2f2 100%);
}

/* You can add global styles to this file, and also import other style files */
body, html {
  height: 100vh;
  margin: 0;
}

body {
  font-family: Arial, sans-serif;
  height: 100vh;
  background-color: #fff; /* Background color for the top half */
  position: relative;
  display: block;
  justify-content: center;
  align-items: center;
}

body::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 50%;
  background: #fff;
  z-index: -1; /* Ensure the gradient is behind other content */
}

/* Old palette
\$theme-main: #B05995;
\$theme-contrast: #3792BF;
\$theme-1: #282B59;
\$theme-2: #D683DD;
\$theme-3: #27567A;
\$theme-4: #44DDC4;
\$theme-5: #3336AE;
\$theme-6: #18C43D;
*/
.material-symbols-outlined {
  cursor: pointer;
  font-variation-settings: "FILL" 0, "wght" 400, "GRAD" 0, "opsz" 48;
}

p {
  font-family: Arial, Helvetica, sans-serif;
  text-align: justify;
  color: #2D2D2A;
}

html, body {
  height: 100%;
}

body {
  margin: 0;
  font-family: Roboto, "Helvetica Neue", sans-serif;
}

.generic-button, .generic-button-alt {
  color: white;
  border-radius: 5px; /* Rounded corners */
  padding: 10px 20px; /* Padding for button size */
  margin-right: 10px;
  cursor: pointer; /* Pointer on hover */
  transition: background-color 0.3s; /* Smooth transition on hover */
}
.generic-button p, .generic-button-alt p {
  color: white;
  margin: 0;
}

.generic-button {
  background-color: #1B3E78; /* Button background color */
  border: 2px solid #1B3E78; /* No border */
}

.generic-button-alt {
  background-color: #0CAD99; /* Button background color */
  border: 2px solid #0CAD99; /* No border */
}

.generic-button:hover {
  background-color: #fff; /* Change color on hover */
  color: #1B3E78;
}
.generic-button:hover p {
  color: #1B3E78;
}

.generic-button-alt:hover {
  background-color: #fff; /* Change color on hover */
  color: #0CAD99;
}
.generic-button-alt:hover p {
  color: #0CAD99;
}

.generic-button:disabled, .generic-button-alt:disabled {
  background-color: #e7e7e7;
  border-color: #e7e7e7;
  cursor: not-allowed;
}

.rDNA-sidebar-container {
  min-height: 100%;
  min-width: 100%;
  background: #F4F7FE;
}
.rDNA-sidebar-container .rDNA-activeLink {
  color: #0CAD99 !important;
  background-color: #e7e7e7;
  border-radius: 0px 10px 10px 0px;
}
.rDNA-sidebar-container .rDNA-sidenav {
  background: #F4F7FE;
  border-right: none;
  height: 100%;
  z-index: 1;
}
.rDNA-sidebar-container .rDNA-navList {
  background: #1B3E78;
  height: 90%;
  border-radius: 15px;
}
.rDNA-sidebar-container .rDNA-listItem {
  flex-wrap: nowrap;
  align-items: center;
}
.rDNA-sidebar-container .rDNA-linkTxt {
  color: #e7e7e7;
  margin-left: 10px;
}
.rDNA-sidebar-container .rDNA-linkTxt-active {
  color: #0CAD99;
  margin-left: 10px;
}
.rDNA-sidebar-container .rDNA-icon {
  font-size: 18px;
  color: #A3AED0;
}
.rDNA-sidebar-container .rDNA-icon-active {
  font-size: 18px;
  color: #0CAD99;
}
.rDNA-sidebar-container .rDNA-linkContainer {
  flex-wrap: nowrap;
  min-height: 60px;
}
.rDNA-sidebar-container .rDNA-data-banner {
  background-color: #f0f0f0;
  border-radius: 10px;
  padding: 25px 15px;
  margin: 20px 15px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}
.rDNA-sidebar-container .rDNA-data-icon {
  font-size: 32px;
  color: #1B3E78;
  margin-bottom: 20px;
  width: 32px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.rDNA-sidebar-container .rDNA-data-icon .mat-icon {
  font-size: 24px;
  width: 24px;
  height: 24px;
}
.rDNA-sidebar-container .rDNA-data-text {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-bottom: 20px;
}
.rDNA-sidebar-container .rDNA-data-text p {
  margin: 0;
  text-align: center;
}
.rDNA-sidebar-container .rDNA-data-text p:first-child {
  color: #1B3E78;
  margin-bottom: 12px;
}
.rDNA-sidebar-container .rDNA-data-text p:last-child {
  color: #1B3E78;
  margin-bottom: 0;
  max-width: 90%;
  line-height: 1.5;
}
.rDNA-sidebar-container .rDNA-data-button {
  background-color: #0CAD99;
  color: white;
  border: none;
  border-radius: 5px;
  padding: 12px 24px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  margin-top: 10px;
}
.rDNA-sidebar-container .rDNA-data-button:hover {
  background-color: #097d6f;
}
.rDNA-sidebar-container .rDNA-separatorLine {
  width: 90%;
}
.rDNA-sidebar-container .advanced-container {
  width: 100%;
  min-height: 400px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: transparent;
}
.rDNA-sidebar-container .white-box {
  height: 200px;
  border-radius: 10px;
  margin: 10px;
  display: flex;
  flex-direction: column;
}
.rDNA-sidebar-container .rocket-container {
  width: 100%;
  display: flex;
  position: relative;
  top: -120px;
  justify-content: center;
}
.rDNA-sidebar-container .rocket-container img {
  display: block;
  width: 90%;
}
.rDNA-sidebar-container .button-container {
  display: flex;
  flex-direction: column;
  position: relative;
  top: -110px;
  justify-content: center;
  align-items: center;
}
.rDNA-sidebar-container .button-container button {
  background-color: #d9534f;
  width: 120px;
  height: 40px;
  border-radius: 5px;
  border: none;
}
.rDNA-sidebar-container .button-container p {
  margin: 0;
  text-align: center;
  color: white;
  font-weight: bold;
}
.rDNA-sidebar-container .advanced-text {
  position: relative;
  top: -120px;
  font-size: 14px;
  padding: 5px 15px;
  text-align: center;
}

@media screen and (max-width: 1023.7px) and (min-width: 768px) {
  .rDNA-sidebar-container .rDNA-sidenav {
    width: 150px;
  }
  .rDNA-sidebar-container .rDNA-linkTxt {
    font-size: 10px;
  }
  .rDNA-sidebar-container .rDNA-icon {
    font-size: 16px;
  }
  .rDNA-sidebar-container .rDNA-navList {
    margin: 0 0 0 10px;
    padding-top: 5px;
  }
  .rDNA-sidebar-container .rDNA-listItem {
    height: 35px;
    padding: 0;
  }
  .rDNA-sidebar-container .rDNA-data-banner {
    padding: 15px 10px;
    margin: 15px 10px;
  }
  .rDNA-sidebar-container .rDNA-data-icon {
    font-size: 24px;
    margin-bottom: 12px;
  }
  .rDNA-sidebar-container .rDNA-data-text {
    margin-bottom: 12px;
  }
  .rDNA-sidebar-container .rDNA-data-text p:first-child {
    font-size: 14px;
    margin-bottom: 8px;
  }
  .rDNA-sidebar-container .rDNA-data-text p:last-child {
    font-size: 12px;
  }
  .rDNA-sidebar-container .rDNA-data-button {
    font-size: 12px;
    padding: 8px 15px;
  }
}
@media screen and (max-width: 1199.7px) and (min-width: 1024px) {
  .rDNA-sidebar-container .rDNA-sidenav {
    width: 200px;
  }
  .rDNA-sidebar-container .rDNA-linkTxt {
    font-size: 14px;
  }
  .rDNA-sidebar-container .rDNA-icon {
    font-size: 18px;
  }
  .rDNA-sidebar-container .rDNA-navList {
    margin: 0 0 0 15px;
    padding-top: 7px;
  }
  .rDNA-sidebar-container .rDNA-listItem {
    height: 45px;
    padding: 0;
  }
}
@media screen and (max-width: 2559.7px) and (min-width: 1199.7px) {
  .rDNA-sidebar-container .rDNA-sidenav {
    width: 210px;
  }
  .rDNA-sidebar-container .rDNA-linkTxt {
    font-size: 14px;
  }
  .rDNA-sidebar-container .rDNA-icon {
    font-size: 20px;
  }
  .rDNA-sidebar-container .rDNA-navList {
    margin: 0 0 0 10px;
    padding-top: 10px;
  }
  .rDNA-sidebar-container .rDNA-listItem {
    height: 40px;
    padding: 0;
  }
}
@media screen and (min-width: 2560px) {
  .rDNA-sidebar-container .rDNA-sidenav {
    width: 400px;
  }
  .rDNA-sidebar-container .rDNA-linkTxt {
    font-size: 20px;
  }
  .rDNA-sidebar-container .rDNA-icon {
    font-size: 25px;
  }
  .rDNA-sidebar-container .rDNA-navList {
    margin: 0 0 0 25px;
    padding-top: 25px;
  }
  .rDNA-sidebar-container .rDNA-listItem {
    height: 75px;
    padding: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/theme/fonts.scss","webpack://./src/app/lbarometer/shared/lb-sidebar/lb-sidebar.component.scss","webpack://./src/theme/variables.scss","webpack://./src/theme/placeholders/_fonts.scss","webpack://./src/theme/mixins.scss","webpack://./src/theme/placeholders/_flexboxes.scss","webpack://./src/app/lbarometer/styles.scss","webpack://./node_modules/ngx-sharebuttons/themes/variables.scss","webpack://./node_modules/ngx-sharebuttons/themes/default.scss","webpack://./node_modules/ngx-sharebuttons/themes/circles.scss","webpack://./src/styles.scss"],"names":[],"mappings":"AAAA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,6CAAA;ACCF;ADEA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iDAAA;ACAF;ADGA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,4CAAA;ACDF;ADIA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gDAAA;ACFF;ADKA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,8CAAA;ACHF;ADMA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,+CAAA;ACJF;ADOA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,6CAAA;ACLF;ADQA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;ACNF;ADSA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,4CAAA;ACPF;ADUA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mDAAA;ACRF;ADWA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,uDAAA;ACTF;ADYA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;ACVF;ADaA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sDAAA;ACXF;ADcA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,oDAAA;ACZF;ADeA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,8CAAA;ACbF;ADgBA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mDAAA;ACdF;ADiBA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,wDAAA;ACfF;ADkBA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;AChBF;ACpGA;;;;;uBAAA;AFPA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,6CAAA;ACmHF;ADhHA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iDAAA;ACkHF;AD/GA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,4CAAA;ACiHF;AD9GA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gDAAA;ACgHF;AD7GA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,8CAAA;AC+GF;AD5GA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,+CAAA;AC8GF;AD3GA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,6CAAA;AC6GF;AD1GA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;AC4GF;ADzGA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,4CAAA;AC2GF;ADxGA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mDAAA;AC0GF;ADvGA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,uDAAA;ACyGF;ADtGA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;ACwGF;ADrGA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sDAAA;ACuGF;ADpGA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,oDAAA;ACsGF;ADnGA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,8CAAA;ACqGF;ADlGA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mDAAA;ACoGF;ADjGA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,wDAAA;ACmGF;ADhGA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;ACkGF;ACtNA;;;;;uBAAA;ACYA;ECHE,kCFXY;EEYZ,eDE2C;ECD3C,gBATiF;EAUjF,kBALgB;AH2NlB;;AEpNA;ECLE,kCFXY;EEYZ,eDI2C;ECH3C,gBATiF;EAUjF,kBALgB;AHkOlB;;AE1NA;ECNE,kCFXY;EEYZ,eDK2C;ECJ3C,gBATiF;EAUjF,kBALgB;AHyOlB;;AIjPA;EAC0B,aAAA;EACA,mBAAA;AJoP1B;;AK5PA;;;;;;;4BAAA;ACAA,sBAAA;ACEA;EACE,gBAAA;EACA,oCAAA;EACA,uBAAA;EACA,qBAAA;APsQF;AOpQE;EACE,4BAAA;APsQJ;AOpQI;EACE,YAAA;APsQN;;AMlRA,sBAAA;AEME;EACE,gBAAA;EACA,4BAAA;EACA,2BAAA;EACA,wBAAA;EACA,qBAAA;ARgRJ;AQ7QM;EACE,sHAAA;AR+QR;AQ3QI;EACE,qCAAA;EACA,iHAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,2GAAA;AR6QN;AQ1QI;EACE,0BAAA;EACA,gBA3BS;EA4BT,eAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;EACA,kBAAA;EACA,UAAA;EACA,2GAAA;AR4QN;AQzQI;EACE,mBAAA;EACA,sBAAA;AR2QN;;AQpQE;EACE,qCAAA;ARuQJ;AQpQE;EACE,0BAAA;ARsQJ;;AQhQE;EACE,0BAAA;ARmQJ;AQhQE;EACE,uFAAA;ARkQJ;;AS/TA,8EAAA;AAEA;EACA,aAAA;EAEA,SAAA;ATgUA;;AS7TA;EACI,8BAAA;EACA,aAAA;EACA,sBAAA,EAAA,sCAAA;EACA,kBAAA;EACA,cAAA;EACA,uBAAA;EACA,mBAAA;ATgUJ;;AS5TA;EACI,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;EAGA,WAAA,EAAA,gDAAA;AT6TJ;;ASxTA;;;;;;;;;CAAA;AA0CA;EAEI,eAAA;EACA,kEACI;ATyRR;;ASnRA;EACI,yCAAA;EACA,mBAAA;EACA,cAxDS;AT8Ub;;ASjRA;EAAa,YAAA;ATqRb;;ASpRA;EAAO,SAAA;EAAW,iDAAA;ATyRlB;;AStRA;EACE,YAAA;EACA,kBAAA,EAAA,oBAAA;EACE,kBAAA,EAAA,4BAAA;EACA,kBAAA;EAGA,eAAA,EAAA,qBAAA;EACA,iCAAA,EAAA,+BAAA;ATuRJ;ASrRI;EACI,YAAA;EACA,SAAA;ATuRR;;ASpRA;EACE,yBArEW,EAqEoB,4BAAA;EAC/B,yBAAA,EAAA,cAAA;ATuRF;;ASpRA;EACE,yBA7Da,EA6DoB,4BAAA;EACjC,yBAAA,EAAA,cAAA;ATuRF;;ASpRA;EACI,sBAAA,EAAA,0BAAA;EACA,cAhFS;ATuWb;ASrRI;EACI,cAnFK;AT0Wb;;ASnRA;EACE,sBAAA,EAAA,0BAAA;EACA,cA5Ea;ATkWf;ASpRE;EACE,cA/EW;ATqWf;;ASlRA;EACI,yBA/Ec;EAgFd,qBAhFc;EAiFd,mBAAA;ATqRJ;;AA9ZA;EACE,gBAAA;EACA,eAAA;EACA,mBCce;ADmZjB;AA/ZE;EACI,yBAAA;EACA,yBSiDY;EThDZ,gCAAA;AAiaN;AA9ZE;EACE,mBCKa;EDJb,kBAAA;EACA,YAAA;EAEA,UAAA;AA+ZJ;AA7ZE;EACE,mBS4Bc;ET1Bd,WAAA;EACA,mBAAA;AA8ZJ;AA3ZE;EAEE,iBAAA;EACA,mBAAA;AA4ZJ;AAzZE;EAEE,cSuBc;ETtBd,iBAAA;AA0ZJ;AAxZE;EAEE,cSaW;ETZX,iBAAA;AAyZJ;AAtZE;EACE,eAAA;EACA,cCtCY;AD8bhB;AAtZE;EACE,eAAA;EACA,cSGW;ATqZf;AAhZE;EAEE,iBAAA;EACA,gBAAA;AAiZJ;AA9YE;EACE,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;AAgZJ;AA7YE;EACE,eAAA;EACA,cCvEQ;EDwER,mBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AA+YJ;AA7YI;EACE,eAAA;EACA,WAAA;EACA,YAAA;AA+YN;AA3YE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;EACA,mBAAA;AA6YJ;AA3YI;EACE,SAAA;EACA,kBAAA;AA6YN;AA1YI;EAEE,cCpGM;EDqGN,mBAAA;AA2YN;AAxYI;EAEE,cC1GM;ED2GN,gBAAA;EACA,cAAA;EACA,gBAAA;AAyYN;AArYE;EACE,yBSnEW;EToEX,YAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EAEA,sCAAA;EACA,gBAAA;AAsYJ;AApYI;EACE,yBAAA;AAsYN;AAlYE;EACE,UAAA;AAoYJ;AAjYE;EACE,WAAA;EACA,iBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,6BAAA;AAmYJ;AAhYE;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;AAkYJ;AA5XE;EACE,WAAA;EACA,aAAA;EACA,kBAAA;EACA,WAAA;EACA,uBAAA;AA8XJ;AA5XI;EACE,cAAA;EACA,UAAA;AA8XN;AAxXE;EACI,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,WAAA;EACA,uBAAA;EACA,mBAAA;AA0XN;AAxXM;EACE,yBShIG;ETiIH,YAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;AA0XR;AAvXM;EACE,SAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;AAyXR;AArXE;EAEI,kBAAA;EACA,WAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AAsXN;;AAtTA;EAEI;IAAwC,YAAA;EAyT1C;EAxTE;IAAwC,eAAA;EA2T1C;EA1TE;IAAwC,eAAA;EA6T1C;EA5TE;IACE,kBAAA;IACA,gBAAA;EA8TJ;EA5TE;IACE,YAAA;IACA,UAAA;EA8TJ;EA5TE;IACE,kBAAA;IACA,iBAAA;EA8TJ;EA3TE;IACE,eAAA;IACA,mBAAA;EA6TJ;EA1TE;IACE,mBAAA;EA4TJ;EA1TI;IACE,eAAA;IACA,kBAAA;EA4TN;EAzTI;IACE,eAAA;EA2TN;EAvTE;IACE,eAAA;IACA,iBAAA;EAyTJ;AACF;AArTA;EAEI;IAAwC,YAAA;EAuT1C;EAtTE;IAAwC,eAAA;EAyT1C;EAxTE;IAAwC,eAAA;EA2T1C;EA1TE;IACE,kBAAA;IACA,gBAAA;EA4TJ;EA1TE;IACE,YAAA;IACA,UAAA;EA4TJ;AACF;AAxTA;EAEI;IAAwC,YAAA;EA0T1C;EAzTE;IAAwC,eAAA;EA4T1C;EA3TE;IAAwC,eAAA;EA8T1C;EA7TE;IACE,kBAAA;IACA,iBAAA;EA+TJ;EA7TE;IACE,YAAA;IACA,UAAA;EA+TJ;AACF;AA3TA;EAEI;IAAwC,YAAA;EA6T1C;EA5TE;IAAwC,eAAA;EA+T1C;EA9TE;IAAwC,eAAA;EAiU1C;EAhUE;IACE,kBAAA;IACA,iBAAA;EAkUJ;EAhUE;IACE,YAAA;IACA,UAAA;EAkUJ;AACF","sourcesContent":["@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 900;\n  src: url('../assets/DM_Sans/static/DMSans-Black.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 800;\n  src: url('../assets/DM_Sans/static/DMSans-ExtraBold.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 700;\n  src: url('../assets/DM_Sans/static/DMSans-Bold.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 600;\n  src: url('../assets/DM_Sans/static/DMSans-SemiBold.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 500;\n  src: url('../assets/DM_Sans/static/DMSans-Medium.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 400;\n  src: url('../assets/DM_Sans/static/DMSans-Regular.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 300;\n  src: url('../assets/DM_Sans/static/DMSans-Light.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 200;\n  src: url('../assets/DM_Sans/static/DMSans-ExtraLight.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 100;\n  src: url('../assets/DM_Sans/static/DMSans-Thin.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 900;\n  src: url('../assets/DM_Sans/static/DMSans-BlackItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 800;\n  src: url('../assets/DM_Sans/static/DMSans-ExtraBoldItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 700;\n  src: url('../assets/DM_Sans/static/DMSans-BoldItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 600;\n  src: url('../assets/DM_Sans/static/DMSans-SemiBoldItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 500;\n  src: url('../assets/DM_Sans/static/DMSans-MediumItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 400;\n  src: url('../assets/DM_Sans/static/DMSans-Italic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 300;\n  src: url('../assets/DM_Sans/static/DMSans-LightItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 200;\n  src: url('../assets/DM_Sans/static/DMSans-ExtraLightItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 100;\n  src: url('../assets/DM_Sans/static/DMSans-ThinItalic.ttf');\n}\n\n","// Realistically, the stage should likely be the navigation sidebar and content projection fills the content area, but this would alter the entire application stage.\n// It's best to discuss with the team. This allows height and width to be 100% instead of using view sizes, as this is going to impact responsiveness.\n\n@import 'variables';\n@import 'placeholders/fonts';\n@import 'placeholders/flexboxes';\n@import 'variables/breakpoints';\n@import '../../styles.scss';\n@import '../../../../styles.scss';\n\n\n.rDNA-sidebar-container               {\n  min-height: 100%;\n  min-width: 100%;\n  background: $app-background;\n\n  .rDNA-activeLink                      {\n      color: $theme-accent!important;\n      background-color:$theme-lightgray;\n      border-radius:0px 10px 10px 0px;\n     }\n\n  .rDNA-sidenav                         {\n    background: $app-background;\n    border-right: none;\n    height: 100%;\n\n    z-index: 1;\n  }\n  .rDNA-navList                         {\n    background: $theme-secondary;\n    //height: -webkit-fill-available;\n    height:90%;\n    border-radius: 15px;\n\n  }\n  .rDNA-listItem                        {\n    @extend %flex-row;\n    flex-wrap: nowrap;\n    align-items: center;\n\n  }\n  .rDNA-linkTxt                         {\n    @extend %font-12px-bold;\n    color: $theme-lightgray;\n    margin-left: 10px;\n  }\n  .rDNA-linkTxt-active                    {\n    @extend %font-12px-bold;\n    color: $theme-accent;\n    margin-left: 10px;\n\n  }\n  .rDNA-icon                            {\n    font-size: 18px;\n    color: $inactive-text;\n  }\n  .rDNA-icon-active                     {\n    font-size: 18px;\n    color: $theme-accent;\n  }\n  // .rDNA-highlighter                     {\n  //   border-radius: 3px;\n  //   background: $dark-text;\n  //   width: 5px;\n  //   margin: 10px 0;\n  // }\n  .rDNA-linkContainer                   {\n    @extend %flex-row;\n    flex-wrap: nowrap;\n    min-height: 60px;\n\n  }\n  .rDNA-data-banner {\n    background-color: #f0f0f0;\n    border-radius: 10px;\n    padding: 25px 15px; // Increased top and bottom padding\n    margin: 20px 15px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n  }\n\n  .rDNA-data-icon {\n    font-size: 32px; // Increased icon size\n    color: $dark-text;\n    margin-bottom: 20px; // Increased bottom margin\n    width: 32px;\n    height: 32px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    .mat-icon {\n      font-size: 24px;\n      width: 24px;\n      height: 24px;\n    }\n  }\n\n  .rDNA-data-text {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    width: 100%;\n    margin-bottom: 20px; // Increased margin at the bottom of the text container\n\n    p {\n      margin: 0;\n      text-align: center;\n    }\n\n    p:first-child {\n      @extend %font-18px-bold; // Increased font size\n      color: $dark-text;\n      margin-bottom: 12px; // Increased spacing between title and description\n    }\n\n    p:last-child {\n      //@extend %font-14px; // Keep font size\n      color: $dark-text; // Make the text darker\n      margin-bottom: 0;\n      max-width: 90%; // Ensure the text doesn't stretch too wide\n      line-height: 1.5; // Slightly increased line height for better readability\n    }\n  }\n\n  .rDNA-data-button {\n    background-color: $theme-accent;\n    color: white;\n    border: none;\n    border-radius: 5px;\n    padding: 12px 24px; // Increased padding\n    cursor: pointer;\n    @extend %font-14px-bold; // Increased font size\n    transition: background-color 0.3s ease;\n    margin-top: 10px; // Increased top margin\n\n    &:hover {\n      background-color: darken($theme-accent, 10%);\n    }\n  }\n\n  .rDNA-separatorLine {\n    width:90%;\n  }\n\n  .advanced-container {\n    width:100%;\n    min-height:400px;\n    display:flex;\n    justify-content: center;\n    align-items: center;\n    background-color: transparent;\n  }\n\n  .white-box {\n    height:200px;\n    border-radius:10px;\n    margin:10px;\n    display:flex;\n    flex-direction:column;\n\n\n\n  }\n\n  .rocket-container {\n    width:100%;\n    display:flex;\n    position:relative;\n    top:-120px;\n    justify-content: center;\n\n    img {\n      display:block;\n      width:90%;\n\n\n    }\n  }\n\n  .button-container {\n      display:flex;\n      flex-direction:column;\n      position:relative;\n      top:-110px;\n      justify-content: center;\n      align-items:center;\n\n      button {\n        background-color: $theme-red;\n        width:120px;\n        height:40px;\n        border-radius:5px;\n        border:none;\n      }\n\n      p {\n        margin:0;\n        text-align:center;\n        color:white;\n        font-weight:bold;\n      }\n  }\n\n  .advanced-text {\n\n      position:relative;\n      top:-120px;\n      font-size:14px;\n      padding: 5px 15px;\n      text-align:center;\n\n  }\n\n  // .rDNA-switchContainer {\n  //   display: flex;\n  //   flex-direction: column; // Stack items vertically\n  //   align-items: center; // Center items horizontally\n  //   margin: 10px 0; // Add some vertical spacing\n\n  //   ::ng-deep mat-slide-toggle {\n  //     // Custom styles for the switch\n  //     margin: 0; // Reset margin if needed\n  //     padding-top: 5px;\n  //     padding-left: 17px;\n\n\n  //     // Additional styles for the toggle\n  //     border-radius: 25px; // Make the toggle rounded\n  //     height: 30px; // Set height for the toggle\n  //     width: 54px; // Set width for the toggle\n\n  //     // Optional: Add a box shadow for better visibility\n  //     box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n  //   }\n  // }\n}\n\n// .mat-mdc-slide-toggle {\n//   // Change the colors for the selected state of the switch\n//   --mdc-switch-selected-focus-state-layer-color: #4caf50; // Focus state layer color (green)\n//   --mdc-switch-selected-handle-color: #ffffff; // Handle color (white when selected)\n//   --mdc-switch-selected-hover-state-layer-color: #66bb6a; // Hover state layer color (light green)\n//   --mdc-switch-selected-pressed-state-layer-color: #388e3c; // Pressed state layer color (darker green)\n\n//   // Set the unfocused handle color to match the sidebar background\n//   --mdc-switch-selected-focus-handle-color: #4caf50; // Focus handle color (green)\n//   --mdc-switch-selected-hover-handle-color: #ffffff; // Hover handle color (white)\n//   --mdc-switch-selected-pressed-handle-color: #ffffff; // Pressed handle color (white)\n\n//   // Unfocused handle color (sidebar color)\n//   --mdc-switch-unselected-handle-color: $app-background; // Set this to your sidebar background color\n//   --mdc-switch-unselected-track-color: #ccc; // Default track color when unchecked\n//   --mdc-switch-selected-focus-track-color: #a5d6a7; // Focus track color (light green)\n//   --mdc-switch-selected-hover-track-color: #a5d6a7; // Hover track color (light green)\n//   --mdc-switch-selected-pressed-track-color: #a5d6a7; // Pressed track color (light green)\n//   --mdc-switch-selected-track-color: #4caf50; // Track color (green)\n// }\n\n// .toggle-swtich-off-span {\n//   font-size: 14px; // Change font size\n//   color: #a3aed0; // Change text color\n//   margin-bottom: 5px; // Space between text and switch\n//   font-weight: bold; // Make the text bold\n// }\n\n// .toggle-swtich-on-span {\n//   font-size: 16px; // Change font size\n//   color: #1B3E79; // Change text color\n//   margin-bottom: 5px; // Space between text and switch\n//   font-weight: bold; // Make the text bold\n// }\n\n\n@media screen and ( max-width: $breakpoint-md-max) and (min-width: $breakpoint-md-min) {\n  .rDNA-sidebar-container               {\n    .rDNA-sidenav                         { width: 150px; }\n    .rDNA-linkTxt                         { font-size: 10px; }\n    .rDNA-icon                            { font-size: 16px; }\n    .rDNA-navList                         {\n      margin: 0 0 0 10px;\n      padding-top: 5px;\n    }\n    .rDNA-listItem                        {\n      height: 35px;\n      padding: 0;\n    }\n    .rDNA-data-banner {\n      padding: 15px 10px;\n      margin: 15px 10px;\n    }\n\n    .rDNA-data-icon {\n      font-size: 24px;\n      margin-bottom: 12px;\n    }\n\n    .rDNA-data-text {\n      margin-bottom: 12px;\n\n      p:first-child {\n        font-size: 14px;\n        margin-bottom: 8px;\n      }\n\n      p:last-child {\n        font-size: 12px;\n      }\n    }\n\n    .rDNA-data-button {\n      font-size: 12px;\n      padding: 8px 15px;\n    }\n  }\n}\n\n@media screen and ( max-width: $breakpoint-lg-max) and (min-width: $breakpoint-lg-min) {\n  .rDNA-sidebar-container               {\n    .rDNA-sidenav                         { width: 200px; }\n    .rDNA-linkTxt                         { font-size: 14px; }\n    .rDNA-icon                            { font-size: 18px; }\n    .rDNA-navList                         {\n      margin: 0 0 0 15px;\n      padding-top: 7px;\n    }\n    .rDNA-listItem                        {\n      height: 45px;\n      padding: 0;\n    }\n  }\n}\n\n@media screen and ( max-width: $breakpoint-xxl-max) and (min-width: $breakpoint-lg-max) {\n  .rDNA-sidebar-container               {\n    .rDNA-sidenav                         { width: 210px; }\n    .rDNA-linkTxt                         { font-size: 14px; }\n    .rDNA-icon                            { font-size: 20px; }\n    .rDNA-navList                         {\n      margin: 0 0 0 10px;\n      padding-top: 10px;\n    }\n    .rDNA-listItem                        {\n      height: 40px;\n      padding: 0;\n    }\n  }\n}\n\n@media screen and (min-width: $breakpoint-xxxl-min) {\n  .rDNA-sidebar-container               {\n    .rDNA-sidenav                         { width: 400px; }\n    .rDNA-linkTxt                         { font-size: 20px; }\n    .rDNA-icon                            { font-size: 25px; }\n    .rDNA-navList                         {\n      margin: 0 0 0 25px;\n      padding-top: 25px;\n    }\n    .rDNA-listItem                        {\n      height: 75px;\n      padding: 0;\n    }\n  }\n}\n","@import \"fonts\";\n\n// this file is more for variables that cannot be used in the theme\n// many of these should be migrated after the material theme has been configured.\n\n$font-family: \"Dm Sans\", sans-serif;\n\n/* Old palette\n$accent-btn: #DD7EB0;\n$dark-text: #303f71;\n$light-text: #fff;\n$inactive-text: #A3AED0;\n$accent-blue: #84D9FD;*/\n\n$accent-btn: #0CAD99;\n$dark-text: #1B3E78;\n$light-text: #fff;\n$inactive-text: #A3AED0;\n$accent-blue: #3792BF;\n\n$theme-main: #1B3E78;\n$theme-contrast: #0CAD99;\n$theme-1: #3792BF;\n$theme-2: #AACCFF;\n$theme-3: #BDBDBD;\n$theme-4: #7D7979;\n$theme-5: #787c95;\n\n$app-background: #F4F7FE;\n\n$rDNA-success: #00B300;\n$rDNA-alert: #FF0000;\n$rDNA-neutral: #FFBF00;\n","@import '../mixins';\n\n/////////////////////////////////////\n//   Extra Bold Font Placeholders  //\n/////////////////////////////////////\n\n%font-16px-extra-bold { @include format-font(16px, 'extra bold'); }\n\n/////////////////////////////////////\n//     Bold Font Placeholders     //\n/////////////////////////////////////\n\n%font-52px-bold       { @include format-font(52px, 'bold'); }\n%font-48px-bold       { @include format-font(48px, 'bold'); }\n%font-34px-bold       { @include format-font(34px, 'bold'); }\n%font-32px-bold       { @include format-font(32px, 'bold'); }\n%font-28px-bold       { @include format-font(28px, 'bold'); }\n%font-24px-bold       { @include format-font(24px, 'bold'); }\n%font-20px-bold       { @include format-font(20px, 'bold'); }\n%font-18px-bold       { @include format-font(18px, 'bold'); }\n%font-16px-bold       { @include format-font(16px, 'bold'); }\n%font-14px-bold       { @include format-font(14px, 'bold'); }\n%font-12px-bold       { @include format-font(12px, 'bold'); }\n\n\n/////////////////////////////////////\n//   Semi-Bold Font Placeholders   //\n/////////////////////////////////////\n\n%font-24px-semi       { @include format-font(24px, 'semi-bold'); }\n%font-20px-semi       { @include format-font(20px, 'semi-bold'); }\n\n\n/////////////////////////////////////\n//     Medium Font Placeholders    //\n/////////////////////////////////////\n\n%font-30px-medium     { @include format-font(30px, 'medium'); }\n%font-20px-medium     { @include format-font(20px, 'medium'); }\n%font-18px-medium     { @include format-font(18px, 'medium'); }\n%font-16px-medium     { @include format-font(16px, 'medium'); }\n%font-14px-medium     { @include format-font(14px, 'medium'); }\n%font-12px-medium     { @include format-font(12px, 'medium'); }\n%font-10px-medium     { @include format-font(10px, 'medium'); }\n\n/////////////////////////////////////\n//    Normal Font Placeholders     //\n/////////////////////////////////////\n\n%font-18px-normal     { @include format-font(18px); }\n%font-16px-normal     { @include format-font(16px); }\n%font-14px-normal     { @include format-font(14px); }\n%font-12px-normal     { @include format-font(12px); }\n","@import 'variables';\n\n@mixin format-font($size, $weight: 500, $style: 'normal' ) {\n  @if ( $weight == 'thin' or $weight == 'Thin' ) { $weight: 100; }\n  @else if ( $weight == 'extra light' or $weight == 'Extra light' or $weight == 'extra Light' or $weight == 'Extra Light' or  $weight == 'el') { $weight: 200; }\n  @else if ( $weight == 'light' or $weight == 'Light'  or $weight == 'l') { $weight: 300; }\n  @else if ( $weight == 'normal' or $weight == 'Normal'  or $weight == 'n') { $weight: 400; }\n  @else if ( $weight == 'medium' or $weight == 'Medium'  or $weight == 'm') { $weight: 500; }\n  @else if ( $weight == 'semi-bold' or $weight == 'Semi-bold' or $weight == 'semi-Bold' or $weight == 'Semi-Bold' or $weight == 'sb' ) { $weight: 600; }\n  @else if ( $weight == 'bold' or $weight == 'Bold' or $weight == 'b' ) { $weight: 700; }\n  @else if ( $weight == 'extra bold' or $weight == 'Extra bold' or $weight == 'extra Bold' or $weight == 'Extra Bold' or $weight == 'eb' ) { $weight: 800; }\n  @else if ( $weight == 'black' or $weight == 'Black' or $weight == 'blk') { $weight: 900; }\n\n  @if ( $style == 'Italic' or $style == 'i' ) { $style: italic; }\n  @else { $style: normal; }\n\n  font-family: $font-family;\n  font-size: $size;\n  font-weight: $weight;\n  font-style: $style;\n}\n","\n%flex-column            {\n                          display: flex;\n                          flex-direction: column;\n                        }\n\n%flex-row               {\n                          display: flex;\n                          flex-direction: row;\n                        }\n\n%flex-jCenter-aCenter   {\n                          justify-content: center;\n                          align-items: center;\n                        }\n\n%flex-jCenter-aStart    {\n                          justify-content: center;\n                          align-items: flex-start;\n                        }\n\n%flex-jCenter-aEnd      {\n                          justify-content: center;\n                          align-items: flex-end;\n                        }\n\n%flex-jStart-aCenter    {\n                          justify-content: flex-start;\n                          align-items: center;\n                        }\n\n%flex-jStart-aStart     {\n                          justify-content: flex-start;\n                          align-items: flex-start;\n                        }\n\n%flex-jStart-aEnd       {\n                          justify-content: flex-start;\n                          align-items: flex-end;\n                        }\n\n%flex-jEnd-aCenter      {\n                          justify-content: flex-end;\n                          align-items: center;\n                        }\n\n%flex-jEnd-aStart       {\n                          justify-content: flex-end;\n                          align-items: flex-start;\n                        }\n\n%flex-jEnd-aEnd         {\n                          justify-content: flex-end;\n                          align-items: flex-end;\n                        }\n\n","/*\n$theme-darkGray: #7D7979;\n$theme-lightGray: #BDBDBD;\n$theme-peach: #FFF2E1;\n$theme-yellow: #FFBB64;\n$theme-orange: #FF9001;\n$theme-blue: #2A296F;\n$sub-header-theme: #95a5a6;*/\n\n//----\n\n$theme-primary: #3792BF; \n$theme-secondary: #1B3E78; \n$theme-color3: #AACCFF; \n$theme-color4: #BDBDBD; \n$theme-color5: #7D7979; \n$theme-accent: #0CAD99; \n\n$text-gray:#787c95;","/** Colors variables */\r\n\r\n$sb-primary: #2E4057 !default;\r\n$sb-accent: #fff !default;\r\n$sb-facebook: #4267B2 !default;\r\n$sb-twitter: #00acee !default;\r\n$sb-google: #db4437 !default;\r\n$sb-mix: #ff8226 !default;\r\n$sb-linkedin: #006fa6 !default;\r\n$sb-pinterest: #bd081c !default;\r\n$sb-reddit: #ff4006 !default;\r\n$sb-tumblr: #36465d !default;\r\n$sb-whatsapp: #25d366 !default;\r\n$sb-messenger: #0080FF !default;\r\n$sb-telegram: #0088cc !default;\r\n$sb-xing: #006567 !default;\r\n$sb-email: #FF961C !default;\r\n$sb-viber: #665ca7 !default;\r\n$sb-vk: #4C75A3 !default;\r\n$sb-copy: #607D8B !default;\r\n$sb-print: #765AA2 !default;\r\n$sb-sms: #20c16c !default;\r\n$sb-gray: #a5a5a5 !default;\r\n$sb-expand: #FF6651 !default;\r\n$sb-line: #00b900 !default;\r\n\r\n$sb-buttons: (\r\n  facebook: $sb-facebook,\r\n  twitter: $sb-twitter,\r\n  google: $sb-google,\r\n  mix: $sb-mix,\r\n  line: $sb-line,\r\n  linkedin: $sb-linkedin,\r\n  pinterest: $sb-pinterest,\r\n  reddit: $sb-reddit,\r\n  tumblr: $sb-tumblr,\r\n  whatsapp: $sb-whatsapp,\r\n  messenger: $sb-messenger,\r\n  telegram: $sb-telegram,\r\n  xing: $sb-xing,\r\n  sms: $sb-sms,\r\n  email: $sb-email,\r\n  viber: $sb-viber,\r\n  vk: $sb-vk,\r\n  copy: $sb-copy,\r\n  print: $sb-print,\r\n  expand: $sb-expand\r\n) !default;\r\n","@import \"variables\";\r\n\r\n.sb-default .sb-wrapper {\r\n  --sb-color: #{$sb-accent};\r\n  --sb-background: var(--button-color);\r\n  --sb-border-radius: 4px;\r\n  --sb-overflow: hidden;\r\n\r\n  &.sb-show-icon.sb-show-text {\r\n    --sb-text-padding: 0 1em 0 0;\r\n\r\n    .sb-text {\r\n      filter: none;\r\n    }\r\n  }\r\n}\r\n","@import \"variables\";\r\n\r\n$sb-text-shadow: 0 1px 1px rgba(0, 0, 0, 0.3);\r\n$sb-text-size: 0.8em;\r\n\r\n.sb-circles-dark, .sb-circles-light {\r\n  .sb-wrapper {\r\n    --sb-color: #{$sb-accent};\r\n    --sb-background: transparent;\r\n    --sb-min-width: fit-content;\r\n    --sb-height: fit-content;\r\n    --sb-icon-size: 1.4em;\r\n\r\n    &:active {\r\n      .sb-icon {\r\n        box-shadow: 0 7px 8px -4px rgba(0, 0, 0, .2), 0 12px 17px 2px rgba(0, 0, 0, .14), 0 5px 22px 4px rgba(0, 0, 0, .12);\r\n      }\r\n    }\r\n\r\n    .sb-icon {\r\n      background-color: var(--button-color);\r\n      box-shadow: 0 3px 5px -1px rgba(0, 0, 0, .2), 0 6px 10px 0 rgba(0, 0, 0, .14), 0 1px 18px 0 rgba(0, 0, 0, .12);\r\n      width: 2.5em;\r\n      min-height: 2.5em;\r\n      border-radius: 50%;\r\n      transition: background .4s cubic-bezier(.25, .8, .25, 1), box-shadow 280ms cubic-bezier(.4, 0, .2, 1);\r\n    }\r\n\r\n    .sb-text {\r\n      color: var(--button-color);\r\n      font-size: $sb-text-size;\r\n      margin-top: 5px;\r\n      border-radius: 1em;\r\n      width: 100%;\r\n      height: 1.8em;\r\n      line-height: 1.8em;\r\n      padding: 0;\r\n      transition: background .4s cubic-bezier(.25, .8, .25, 1), box-shadow 280ms cubic-bezier(.4, 0, .2, 1);\r\n    }\r\n\r\n    .sb-content {\r\n      align-items: center;\r\n      flex-direction: column;\r\n    }\r\n  }\r\n}\r\n\r\n.sb-circles-dark .sb-wrapper {\r\n\r\n  .sb-icon {\r\n    background-color: var(--button-color);\r\n  }\r\n\r\n  .sb-text {\r\n    color: var(--button-color);\r\n  }\r\n}\r\n\r\n.sb-circles-light .sb-wrapper {\r\n\r\n  .sb-icon, .sb-text {\r\n    color: var(--button-color);\r\n  }\r\n\r\n  .sb-icon {\r\n    background: radial-gradient(ellipse farthest-corner at center, white 30%, darken(white, 5%) 100%);\r\n  }\r\n}\r\n","\n@import \"../node_modules/ngx-sharebuttons/themes/default.scss\";\n@import \"../node_modules/ngx-sharebuttons/themes/circles.scss\";\n\n/* You can add global styles to this file, and also import other style files */\n\nbody, html {\nheight: 100vh;\n// width: 100vh;\nmargin: 0;\n}\n\nbody {\n    font-family: Arial, sans-serif;\n    height: 100vh;\n    background-color: #fff; /* Background color for the top half */\n    position: relative;\n    display: block;\n    justify-content: center;\n    align-items: center;\n    }\n\n\nbody::after {\n    content: \"\";\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: 50%;\n    background: #fff;\n\n\n    z-index: -1; /* Ensure the gradient is behind other content */\n}\n\n\n$theme-back: #2D2D2A;\n/* Old palette\n$theme-main: #B05995;\n$theme-contrast: #3792BF;\n$theme-1: #282B59;\n$theme-2: #D683DD;\n$theme-3: #27567A;\n$theme-4: #44DDC4;\n$theme-5: #3336AE;\n$theme-6: #18C43D;\n*/\n\n$theme-main: #1B3E78;\n$theme-contrast: #0CAD99;\n$theme-1: #3792BF;\n$theme-2: #AACCFF;\n$theme-3: #BDBDBD;\n$theme-4: #7D7979;\n$theme-5: #787c95;\n\n$theme-primary: #3792BF;\n$theme-secondary: #1B3E78;\n$theme-color3: #AACCFF;\n$theme-color4: #BDBDBD;\n$theme-color5: #7D7979;\n$theme-accent: #0CAD99;\n$text-gray:#787c95;\n$theme-red:#d9534f;\n\n$theme-back-light: #4c4c47;\n$theme-lightgray: #e7e7e7;\n$theme-gray-text: #787476;\n\n$theme-table-header: #f6f6f6;\n$theme-table-body:#f8f8f8;\n$theme-source:#9E9E9E;\n\n\n$value-chain-1: #44DDC4;\n$value-chain-2: \"\";\n$value-chain-3: \"\";\n$value-chain-4: \"\";\n\n.material-symbols-outlined {\n\n    cursor: pointer;\n    font-variation-settings:\n        'FILL' 0,\n        'wght' 400,\n        'GRAD' 0,\n        'opsz' 48;\n}\n\np {\n    font-family:Arial, Helvetica, sans-serif;\n    text-align: justify;\n    color: $theme-back;\n}\n\n\n\nhtml, body { height: 100%; }\nbody { margin: 0; font-family: Roboto, \"Helvetica Neue\", sans-serif; }\n\n\n.generic-button, .generic-button-alt {\n  color: white;\n  border-radius: 5px;   /* Rounded corners */\n    padding: 10px 20px;    /* Padding for button size */\n    margin-right: 10px;\n\n    // font-size: 16px;       /* Font size */\n    cursor: pointer;       /* Pointer on hover */\n    transition: background-color 0.3s; /* Smooth transition on hover */\n\n    p {\n        color:white;\n        margin:0;\n    }\n}\n.generic-button {\n  background-color: $theme-main; /* Button background color */\n  border: 2px solid $theme-main;      /* No border */\n}\n\n.generic-button-alt {\n  background-color: $theme-accent; /* Button background color */\n  border: 2px solid $theme-accent;      /* No border */\n}\n\n.generic-button:hover {\n    background-color: #fff; /* Change color on hover */\n    color: $theme-main;\n\n    p {\n        color: $theme-main\n    }\n}\n\n.generic-button-alt:hover {\n  background-color: #fff; /* Change color on hover */\n  color: $theme-accent;\n\n  p {\n    color: $theme-accent\n  }\n}\n\n.generic-button:disabled, .generic-button-alt:disabled {\n    background-color: $theme-lightgray;\n    border-color: $theme-lightgray;\n    cursor:not-allowed;\n\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
